import { render, staticRenderFns } from "./chat-message-image.vue?vue&type=template&id=19224874&scoped=true"
import script from "./chat-message-image.vue?vue&type=script&lang=js"
export * from "./chat-message-image.vue?vue&type=script&lang=js"
import style0 from "./chat-message-image.vue?vue&type=style&index=0&id=19224874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19224874",
  null
  
)

export default component.exports